/**
 * Central color configuration for the application
 * Update colors here to change theme across the entire application
 * 
 * This file exports color constants for use in JavaScript/React components
 * For CSS, use the CSS variables defined in styling/colors.css
 */

export const COLORS = {
  // Primary dark green colors
  PRIMARY: '#15803d',
  PRIMARY_DARK: '#14532d',
  
  // Primary color RGB values for transparency
  PRIMARY_RGB: [21, 128, 61],
  PRIMARY_DARK_RGB: [20, 83, 45],
  
  // Helper functions for rgba colors
  rgba: (r, g, b, a) => `rgba(${r}, ${g}, ${b}, ${a})`,
  primaryRgba: (alpha) => `rgba(21, 128, 61, ${alpha})`,
  primaryDarkRgba: (alpha) => `rgba(20, 83, 45, ${alpha})`,
  
  // Common gradients
  gradientPrimary: 'linear-gradient(135deg, #15803d 0%, #14532d 100%)',
  gradientPrimaryRgba: (alpha1, alpha2) => 
    `linear-gradient(135deg, rgba(21, 128, 61, ${alpha1}) 0%, rgba(20, 83, 45, ${alpha2}) 100%)`,
};

// Common opacity values
export const OPACITY = {
  LIGHT: 0.05,
  MEDIUM: 0.1,
  STRONG: 0.15,
  VERY_STRONG: 0.2,
  STRONGER: 0.25,
  SHADOW: 0.3,
  SHADOW_STRONG: 0.4,
  SHADOW_VERY_STRONG: 0.5,
  SHADOW_INTENSE: 0.7,
};

